interface props {
  itemsCount: number;
  currentSlide: number;
  onIndicatorClick: (param: number) => void;
}
export const ExternalIndicator = ({
  itemsCount,
  currentSlide,
  onIndicatorClick,
}: props) => {
  return (
    <ul className="flex w-full h-[50px] items-center justify-center ">
      {Array.from({ length: itemsCount }).map((_, index) => (
        <li
          key={index}
          onClick={() => onIndicatorClick(index)}
          className={`w-3 h-3 rounded-full mr-3 ${
            currentSlide === index
              ? "bg-black opacity-100"
              : "bg-custom-black opacity-50"
          }`}
        />
      ))}
    </ul>
  );
};
